import type { GroupedPlayerRewardDto, PlayerRewardDto, PlayerRewardListDto, PlayerRewardParams } from './playerGamificationRewards.schema';
import { validateWithZod } from '@/utils/zod.utils';
import { ENDPOINTS } from '../endpoints';
import { httpClient } from '../httpClient';
import { PaginationSchema } from '../types/Pagination.types';
import { ClaimedPlayerRewardDtoScema, GroupedPlayerRewardListDtoSchema, PlayerRewardDtoSchema } from './playerGamificationRewards.schema';

export const playerGamificationRewards = {

  async getMeRewards(params?: PlayerRewardParams) {
    const response = await httpClient.get<PlayerRewardListDto>(
      ENDPOINTS.gamification.playerRewards.rewards,
      { params },
    );

    return validateWithZod(PaginationSchema(PlayerRewardDtoSchema), response);
  },

  async getMeGroupedRewards() {
    const response = await httpClient.get<GroupedPlayerRewardDto[]>(
      ENDPOINTS.gamification.playerRewards.groupedRewards,
    );

    return validateWithZod(GroupedPlayerRewardListDtoSchema, response);
  },

  async claimReward(id: string) {
    const response = await httpClient.post<PlayerRewardDto>(
      ENDPOINTS.gamification.playerRewards.claimReward(id),
    );

    return validateWithZod(ClaimedPlayerRewardDtoScema, response);
  },

};
